"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var LabelDropdownButton = function LabelDropdownButton(_ref) {
  var children = _ref.children,
    id = _ref.id,
    placeholder = _ref.placeholder,
    presenter = _ref.presenter,
    renderValue = _ref.renderValue,
    isLoading = _ref.isLoading,
    value = _ref.value;
  var text = isLoading ? undefined : presenter.renderLabel(value, children, renderValue);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    title: text,
    className: "dropdown-label",
    placeholder: placeholder
  }, text);
};
var _default = exports["default"] = LabelDropdownButton;